import { Spinner } from "@visiblethread/react-components";
import clsx from "clsx";
import { Pin } from "lucide-react";
import { bool, shape, string } from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  pinSharepointSite,
  unpinSharepointSite,
} from "slices/sharepoint/actions";
import { updateSitePinnedStatus } from "slices/sharepoint/sharepointSlice";

const PinAction = ({ item }) => {
  const dispatch = useDispatch();
  const [isPinningLoading, setIsPinningLoading] = useState(false);

  const handlePinClick = async (e) => {
    e.stopPropagation();
    setIsPinningLoading(true);

    if (item.isPinned) {
      const response = await dispatch(unpinSharepointSite(item.id));
      if (response) {
        dispatch(
          updateSitePinnedStatus({
            siteId: item.id,
            isPinned: false,
          })
        );
      }
    } else {
      const response = await dispatch(pinSharepointSite(item.id));
      if (response) {
        dispatch(
          updateSitePinnedStatus({
            siteId: item.id,
            isPinned: true,
          })
        );
      }
    }

    setIsPinningLoading(false);
  };

  if (isPinningLoading) {
    return <Spinner size={12} />;
  }

  return (
    <button
      className={clsx("file_explorer__list__item__actions__pinning", {
        isPinned: item.isPinned,
      })}
      onClick={handlePinClick}
    >
      <Pin height={14} width={12} />
    </button>
  );
};

PinAction.propTypes = {
  item: shape({
    id: string.isRequired,
    isPinned: bool,
    name: string.isRequired,
  }).isRequired,
};

export default PinAction;
